<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_cards'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row gap-2">
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Class">
                    <v-select
                      :options="
                        schoolclasses.filter(
                          (schoolclass) => schoolclass.level == 1,
                        )
                      "
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-1 ps-0 pe-1" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      @input="FilterExams"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Filter by">
                    <select
                      class="form-control"
                      v-model="filterby"
                      @change="FilterBy"
                      aria-placeholder="All students"
                    >
                      <option value="1" selected>All students</option>
                      <option value="2">One student</option>
                    </select>
                  </b-form-group>
                  <b-form-group
                    class="col-md-3 ps-0 pe-1"
                    v-if="filterby == 2"
                    label="Student"
                  >
                    <v-select
                      readonly="true"
                      :options="
                        students.filter(
                          (student) => student.class.id == schoolclass.id,
                        )
                      "
                      placeholder="Select Student"
                      v-model="student"
                      :reduce="(students) => students.student.student_id"
                    >
                      <template slot="option" slot-scope="option">
                        <div>
                          {{ option.student.first_name }}
                          {{ option.student.last_name }}
                          {{ option.class.name }} {{ option.stream.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div>
                          {{ option.student.first_name }}
                          {{ option.student.last_name }}
                          {{ option.class.name }} {{ option.stream.name }}
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>

              <div v-if="exammarks.length > 0">
                <div class="text-center">
                  <router-link
                    :to="{
                      path: '/printreport',
                      query: {
                        term: schoolterm.id,
                        termname: schoolterm.name,
                        year: year,
                        class: schoolclass.id,
                        classname: schoolclass.name,
                      },
                    }"
                    type="button"
                    class="btn-sm btn btn-primary"
                  >
                    <i class="mdi mdi-printer"></i> Print
                  </router-link>
                </div>

                <div v-for="item in exammarks" :key="item.id">
                  <div class="card">
                    <div
                      class="card-body"
                      style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
                    >
                      <div class="d-flex justify-content-between">
                        <div>
                          <span v-if="userData.logo != 0"
                            ><img
                              :src="getLogo(userData.logo)"
                              height="80"/><br
                          /></span>
                          <span v-else
                            ><img
                              src="@/assets/images/logo.png"
                              height="80"/></span
                          ><br />
                        </div>
                        <div></div>
                        <div>
                          <img
                            :src="getFiles(item.students.student_photo)"
                            height="80"
                          />
                        </div>
                      </div>

                      <div class="text-center">
                        <h5 style="color:black" class="text-uppercase mb-0">
                          {{ userData.school }}
                        </h5>
                        <span style="color:black;font-size:12px"
                          >Location : {{ userData.location }}</span
                        ><br />
                        <span style="color:black;font-size:12px"
                          >Telephone : {{ userData.contact }}</span
                        ><br /><br />
                        <span
                          style="color: black;font-size:13px"
                          class="text-uppercase text-decoration-underline"
                          ><b>{{ schoolterm.name }} Report</b></span
                        ><br />
                      </div>

                      <div class="d-flex justify-content-evenly">
                        <div>
                          NAME : {{ item.students.first_name }}
                          {{ item.students.last_name }} <br />
                          CLASS : {{ schoolclass.name }}
                        </div>
                        <div>
                          TERM : {{ schoolterm.name }} <br />
                          YEAR : {{ year }}
                        </div>
                      </div>

                      <!-- Exam Sets Table -->
                      <div class="row mt-3">
                        <div class="col-md-12 mx-auto">
                          <table class="table table-sm">
                            <thead>
                              <tr
                                class="text-uppercase text-align-center"
                                style="border-bottom: 2px solid black;"
                              >
                                <th>Subject</th>
                                <th
                                  v-for="examSet in getSortedExamSets(
                                    item.examSets,
                                  )"
                                  :key="examSet.set.id"
                                >
                                  <strong>{{ examSet.set.name }}</strong>
                                  <br /><small>(100)</small>
                                </th>
                                <th>Comment</th>
                                <th>Initials</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Subject rows -->
                              <tr
                                v-for="subject in getAllSubjects(item.examSets)"
                                :key="subject.id"
                              >
                                <td>{{ subject.name }}</td>
                                <td
                                  v-for="examSet in getSortedExamSets(
                                    item.examSets,
                                  )"
                                  :key="examSet.set.id"
                                >
                                  <div
                                    v-if="
                                      getSubjectMarkInSet(examSet, subject.id)
                                    "
                                  >
                                    <div>
                                      <strong>{{
                                        getSubjectMarkInSet(examSet, subject.id)
                                          .mark
                                      }}</strong>
                                      ({{
                                        getGradeFromAggregate(
                                          getSubjectMarkInSet(
                                            examSet,
                                            subject.id,
                                          ).aggregates,
                                        )
                                      }})
                                    </div>
                                  </div>
                                  <div v-else class="text-muted">-</div>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      getSubjectAggregateFromLastSet(
                                        item.examSets,
                                        subject.id,
                                      )
                                    "
                                  >
                                    <span
                                      v-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '1'
                                      "
                                      >EXCELLENT</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '2'
                                      "
                                      >V.GOOD</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '3'
                                      "
                                      >GOOD</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '4'
                                      "
                                      >GOOD</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '5'
                                      "
                                      >FAIR</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '6'
                                      "
                                      >AIM HIGHER</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '7'
                                      "
                                      >WORK HARDER</span
                                    >
                                    <span
                                      v-else-if="
                                        getSubjectAggregateFromLastSet(
                                          item.examSets,
                                          subject.id,
                                        ) == '8'
                                      "
                                      >IMPROVE</span
                                    >
                                    <span v-else>POOR</span>
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      getSubjectTeacher(
                                        item.examSets,
                                        subject.id,
                                      )
                                    "
                                  >
                                    {{
                                      Initials(
                                        getSubjectTeacher(
                                          item.examSets,
                                          subject.id,
                                        ),
                                      )
                                    }}
                                  </span>
                                </td>
                              </tr>

                              <!-- Totals and Aggregates Row -->
                              <tr
                                class="text-uppercase font-weight-bold bg-light"
                              >
                                <td>
                                  <strong class="text-uppercase">Total</strong>
                                </td>
                                <td
                                  v-for="examSet in getSortedExamSets(
                                    item.examSets,
                                  )"
                                  :key="examSet.set.id"
                                >
                                  <div>
                                    <strong>{{ examSet.total }}</strong>
                                  </div>
                                </td>

                                <!-- Division and Aggregates only for the last exam set -->
                                <td>
                                  DIVISION:
                                  <strong>{{
                                    getLastExamSetDivision(item.examSets)
                                  }}</strong>
                                </td>
                                <td>
                                  AGGS:
                                  <strong>{{
                                    getLastExamSetAggregates(item.examSets)
                                  }}</strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between mt-2">
                        <div>
                          <h5 class="text-uppercase">Class Teacher</h5>
                          <br />
                          <span
                            >Comment:
                            <span class="text-uppercase">{{
                              getCommentForAggregate(
                                getLastExamSetAggregates(item.examSets),
                                comment_groups,
                                1,
                              )
                            }}</span></span
                          ><br />
                          <span class="signature-line">
                            Signature :
                            <span
                              v-if="getSignatureForStatus(comment_groups, 1)"
                            >
                              <img
                                :src="getSignatureForStatus(comment_groups, 1)"
                                height="30"
                                alt="Class Teacher Signature"
                              />
                            </span>
                            <span v-else
                              >................................................</span
                            >
                          </span>
                        </div>
                        <div>
                          <h5 class="text-uppercase">Head Teacher</h5>
                          <br />
                          <span
                            >Comment:
                            <span class="text-uppercase">{{
                              getCommentForAggregate(
                                getLastExamSetAggregates(item.examSets),
                                comment_groups,
                                2,
                              )
                            }}</span></span
                          ><br />
                          <span class="signature-line">
                            Signature :
                            <span
                              v-if="getSignatureForStatus(comment_groups, 2)"
                            >
                              <img
                                :src="getSignatureForStatus(comment_groups, 2)"
                                height="30"
                                alt="Head Teacher Signature"
                              />
                            </span>
                            <span v-else
                              >..................................................</span
                            >
                          </span>
                        </div>
                      </div>

                      <!-- <br><br><span>Next Term Begins on : <strong>{{userData.next_term}}</strong></span> -->
                      <br /><span
                        >Next Term Begins on :
                        <strong class="text-uppercase">
                          {{ date(userData.next_term) }}</strong
                        ></span
                      >
                      <center>
                        <qr-code
                          :text="
                            `https://app.schooldynamics.cloud/viewreport?school=${userData.school_id ||
                              1}&student=${item.students.student_id}&term=${
                              schoolterm.id
                            }&year=${year}&class=${schoolclass.id}`
                          "
                          :size="100"
                          error-level="L"
                        ></qr-code>
                      </center>
                      <div class="row mt-3">
                        <div class="col-md-10 mx-auto">
                          <div class="mt-4">
                            <h5>Grading:</h5>
                            <table class="table table-sm" border="3">
                              <tr v-for="x in item.grading" :key="x.id">
                                <td>{{ x.d1 }}</td>
                                <td>{{ x.d2 }}</td>
                                <td>{{ x.c3 }}</td>
                                <td>{{ x.c4 }}</td>
                                <td>{{ x.c5 }}</td>
                                <td>{{ x.c6 }}</td>
                                <td>{{ x.p7 }}</td>
                                <td>{{ x.p8 }}</td>
                                <td>{{ x.f9 }}</td>
                              </tr>
                              <tr>
                                <th>D1</th>
                                <th>D2</th>
                                <th>C3</th>
                                <th>C4</th>
                                <th>C5</th>
                                <th>C6</th>
                                <th>P7</th>
                                <th>P8</th>
                                <th>F9</th>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Report Cards",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Report Cards", active: true },
      ],
      id: "",
      schoolsubjects: [],
      schoolsubject: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      exams: [],
      year: new Date().getFullYear(),
      aggregates: "",
      exammarks: [],
      filterby: "1",
      student: "",
      student_id: "",
      comment_groups: [],
    };
  },
  computed: {
    ...schooltermComputed,
    ...schoolclassComputed,
    ...studentComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.fetchStudents();
    this.TotalRows = this.exammarks.length;
    this.isBusy = false;
  },

  methods: {
    ...schooltermMethods,
    ...schoolclassMethods,
    ...studentMethods,

    // exam sets by rank
    getSortedExamSets(examSets) {
      if (!examSets || !Array.isArray(examSets)) return [];
      return [...examSets].sort((a, b) => a.set.rank - b.set.rank);
    },

    // the last exam set (highest rank)
    getLastExamSet(examSets) {
      if (!examSets || !Array.isArray(examSets)) return null;
      const sorted = this.getSortedExamSets(examSets);
      return sorted.length > 0 ? sorted[sorted.length - 1] : null;
    },

    // all subjects from all exam sets
    getAllSubjects(examSets) {
      if (!examSets || !Array.isArray(examSets)) return [];
      const subjects = [];
      const subjectIds = new Set();

      examSets.forEach((examSet) => {
        if (examSet.exammarks && Array.isArray(examSet.exammarks)) {
          examSet.exammarks.forEach((exammark) => {
            if (
              exammark.subjects &&
              exammark.subjects[0] &&
              !subjectIds.has(exammark.subjects[0].id)
            ) {
              subjects.push(exammark.subjects[0]);
              subjectIds.add(exammark.subjects[0].id);
            }
          });
        }
      });

      return subjects.sort((a, b) => a.name.localeCompare(b.name));
    },

    // subject mark for each exam set
    getSubjectMarkInSet(examSet, subjectId) {
      if (!examSet.exammarks || !Array.isArray(examSet.exammarks)) return null;

      const exammark = examSet.exammarks.find(
        (em) =>
          em.subjects && em.subjects[0] && em.subjects[0].id === subjectId,
      );
      return exammark && exammark.mark && exammark.mark[0]
        ? exammark.mark[0]
        : null;
    },

    //subject aggregate from the last exam set (for comments)
    getSubjectAggregateFromLastSet(examSets, subjectId) {
      if (!examSets || !Array.isArray(examSets)) return null;

      const lastExamSet = this.getLastExamSet(examSets);
      if (!lastExamSet) return null;

      if (lastExamSet.exammarks && Array.isArray(lastExamSet.exammarks)) {
        const exammark = lastExamSet.exammarks.find(
          (em) =>
            em.subjects && em.subjects[0] && em.subjects[0].id === subjectId,
        );
        if (
          exammark &&
          exammark.mark &&
          exammark.mark[0] &&
          exammark.mark[0].aggregates
        ) {
          return exammark.mark[0].aggregates.toString();
        }
      }
      return null;
    },

    //subject teacher (based on first exam )
    getSubjectTeacher(examSets, subjectId) {
      if (!examSets || !Array.isArray(examSets)) return "";

      for (let examSet of examSets) {
        if (examSet.exammarks && Array.isArray(examSet.exammarks)) {
          const exammark = examSet.exammarks.find(
            (em) =>
              em.subjects && em.subjects[0] && em.subjects[0].id === subjectId,
          );
          if (exammark && exammark.teacher && exammark.teacher.full_name) {
            return exammark.teacher.full_name;
          }
        }
      }
      return "";
    },

    // aggregates from the last exam set
    getLastExamSetAggregates(examSets) {
      const lastExamSet = this.getLastExamSet(examSets);
      if (!lastExamSet || !lastExamSet.aggregates) return null;
      return parseInt(lastExamSet.aggregates);
    },

    // division from the last exam set
    getLastExamSetDivision(examSets) {
      const aggregates = this.getLastExamSetAggregates(examSets);
      if (!aggregates) return "";

      if (aggregates <= 12) return "DI";
      if (aggregates <= 23) return "DII";
      if (aggregates <= 29) return "DIII";
      if (aggregates <= 34) return "DIV";
      return "U";
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    Initials(speaker) {
      if (!speaker) return "";
      const name = speaker.split(" ");
      return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ""}`;
    },

    getLogo(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },

    async FilterExams() {
      let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },

    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },

    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("student_id", this.student);

      let url = "/viewreportmarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.marks;
      });

      axios.get(`/comment-group/${this.schoolclass.id}`).then((response) => {
        if (response.status == 200) {
          this.comment_groups = response.data.comment_groups;
        }
      });
    },

    //aggregate number to grade letter
    getGradeFromAggregate(aggregate) {
      3;
      if (!aggregate) return "";

      const agg = parseInt(aggregate);

      if (agg === 1) return "D1";
      if (agg === 2) return "D2";
      if (agg >= 3 && agg <= 6) return `C${agg}`;
      if (agg >= 7 && agg <= 8) return `P${agg}`;
      if (agg === 9) return "F9";

      return aggregate.toString();
    },

    // to get comment based on aggregates and status
    // getCommentForAggregate(aggregate, comment_groups, status) {
    //   const agg = parseInt(aggregate);
    //   for (let group of comment_groups) {
    //     const start = parseInt(group.start_agg);
    //     const end = parseInt(group.end_agg);
    //     if (group.status === status && agg >= start && agg <= end) {
    //       return group.comment;
    //     }
    //   }
    //   return " - ";
    // },

    getCommentForAggregate(aggregate, comment_groups, status) {
      const agg = parseInt(aggregate);
      for (let group of comment_groups) {
        const start = parseInt(group.start_agg);
        const end = parseInt(group.end_agg);
        if (group.status == status && agg >= start && agg <= end) {
          return group.comment;
        }
      }
      return " - ";
    },

    // CT & HT signature for specific status
    getSignatureForStatus(comment_groups, status) {
      if (
        !comment_groups ||
        !Array.isArray(comment_groups) ||
        comment_groups.length === 0
      ) {
        return null;
      }
      const group = comment_groups.find(
        (group) => group.status === status && group.signature,
      );

      if (group && group.signature) {
        let url = axios.defaults.baseURL;
        let imagelink = url.slice(0, -3) + "signatures/" + group.signature;
        return imagelink;
      }
      return null;
    },
    date(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };
      return `${getDaySuffix(day)} ${month} ${year}`;
    },

    FilterBy() {},
  },
};
</script>

<style>
table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.font-weight-bold {
  font-weight: bold !important;
}
</style>
]
